// src/Pages/PreOrder/FaceValidation/constants.js

export const FACE_DETECTION_CONFIG = {
  // Face size parameters
  ratio: {
    min: 0.24, // Minimum ratio between face height and image height (less than this = too far)
    max: 0.4, // Maximum ratio (more than this = too close)
  },

  // Face position parameters
  position: {
    centerThreshold: 0.4, // Allowed deviation from image center (as percentage of size)
    edgeBuffer: 8, // Minimum distance from edges (in pixels)
  },
  // Face detection model parameters
  model: {
    inputSize: 320, // Model input size (affects speed and accuracy)
    confidenceThreshold: 0.5, // Minimum confidence threshold for detection
  },

  // User messages - in gallery
  messages: {
    tooFar: "הפנים בתמונה רחוקות מדי - יש לבחור תמונה אחרת",
    tooNear: "הפנים בתמונה קרובות מדי - יש לבחור תמונה אחרת",
    good: "מעולה! התמונה תקינה",
    noFace: "לא זוהו פנים בתמונה - נא לבחור תמונה אחרת",
    multipleFaces: "זוהו מספר פנים בתמונה - נא לבחור תמונה עם פנים אחת בלבד",
    notCentered: "הפנים אינן ממורכזות בתמונה - נא לבחור תמונה אחרת",  },

  // User messages - in camera (real-time)
  cameraMessages: {
    tooFar: "רחוק מדי – התקרב/י",
    tooNear: "קרוב מדי – התרחק/י מעט",
    good: "מיקום מצוין! ניתן לצלם",
    noFace: "לא זוהו פנים – נא למקם במרכז",
    multipleFaces: "זוהו מספר פנים – נא להציג פנים אחת בלבד",
    notCentered: "נא למקם את הפנים במרכז המסך",
  },
};

// For backward compatibility - keeping the old variable
export const DEFAULT_DISTANCE_CONFIG = {
  minRatio: FACE_DETECTION_CONFIG.ratio.min,
  maxRatio: FACE_DETECTION_CONFIG.ratio.max,
  messages: FACE_DETECTION_CONFIG.messages,
  cameraMessages: FACE_DETECTION_CONFIG.cameraMessages,
};
